import { persistStore } from "redux-persist"

import { appStore } from "./store"

export const persistor = persistStore(appStore, null, () => {
	console.debug("redux-persist: Finished rehydrating;")
})
